export default "__VITE_ASSET__CdJErdfe__"